
var vue;
var promise = new Promise(function (resolve, reject) {
        resolve()
});


class obj {

    promisify (func) {
        promise = promise.then(function(input) {
            return (new Promise(function (resolve, reject) {
                func(resolve, input, reject)
            }))
        }, () => {
            // нужно оставить, чтобы reject не выдавал ошибку
             } );
        return this
    };


        say(text, appendInput = false) {
            return this.$promisify((resolve, input) => {
                this.$dialog(appendInput ? (text + "\n\n" + input) : (text || input), resolve)
            })
        }

        ask(text) {
            return this.$promisify((resolve, input, reject) => {
                this.$dialog.prompt(text || input, resolve, reject)
            })
        }

        confirm(text) {
            console.log('c', text)
            return this.$promisify((resolve, input, reject) => {
                this.$dialog.confirm(text || input, resolve, reject)
            })
        }

        run(action, params) {
            return this.$promisify((resolve, input) => {
                this.$store.dispatch(action, params || input).then(function (data) {
                    resolve(data)
                })
            })
        }
    
        proxy(func) {
            return this.$promisify((resolve, input) => {
                func(input).then((data) => { resolve(data) })
            })
        }

        last(func) {
            return this.$promisify((resolve, input) => {
                func();
                resolve();
            })
        }
    
        info() {
            return this.$promisify((resolve, input) => {
                this.$store.dispatch('showInfo').then(()=> resolve())
            })
            
        }
}


var ooo = new obj()

export default {

    install(Vue) {
        Vue.prototype.$say          = ooo.say;
        Vue.prototype.$ask          = ooo.ask;
        Vue.prototype.$confirm      = ooo.confirm;
        Vue.prototype.$run          = ooo.run;
        Vue.prototype.$proxy        = ooo.proxy;
        Vue.prototype.$last         = ooo.last;
        Vue.prototype.$info         = ooo.info;
        Vue.prototype.$promisify    = ooo.promisify;
    }

}


// WEBPACK FOOTER //
// ./src/plugins/super.js